import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import 'react-toastify/dist/ReactToastify.css'

const Routes = React.lazy(() => import('./routes/routes.tsx'))

import Drawer from 'Components/common/Drawer'
import { useMaintenanceStatus } from './contexts/MaintenanceContext.tsx'
import Toastify from 'Components/common/Toastify'
import Portal from 'Components/common/Portal'

function App() {
  const { setMaintenanceMode } = useMaintenanceStatus();
  const { t } = useTranslation()

  useEffect(() => {
    const maintenanceStartTime = new Date('2025-10-06T10:00:00');
    const maintenanceEndTime = new Date('2025-10-07T14:00:00');
    const currentTime = new Date();

    if (currentTime >= maintenanceStartTime && currentTime <= maintenanceEndTime) {
      setMaintenanceMode(true, t('translation:common.description.servers_under_maintenance'));
    }
  }, [setMaintenanceMode]);

  return (
    <>
      <Routes>
        <Drawer />
        <Portal />
      </Routes>
      <Toastify />
    </>
  )
}

export default App
